var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('img',{class:_vm.s.homeBanner,attrs:{"src":require('./images/aboutBg.jpg')}}),_c('Partners'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }